import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { update, getfloorData } from "../store/actions/floorActions";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { supabase } from "../supabase/supabaseClient";

export default function EditModalGallery(props) {
  const [open, setOpen] = useState(props.Open || false);
  const [isUploading, setIsUploading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const closeDialog = () => {
    setOpen(false);
    setIsUploading(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    setOpen(props.Open);
  }, [props.Open]);

  const saveFile = async (file) => {
    if (file) {
      const fileName = `${Date.now()}${file[0].name}`;
      const fileType = file[0].type;

      try {
        const { error: uploadError } = await supabase.storage
          .from("images")
          .upload(fileName, file[0]);

        if (uploadError) throw uploadError;

        const { data } = supabase.storage.from("images").getPublicUrl(fileName);

        return {
          url: data.publicUrl,
          type: fileType,
        };
      } catch (error) {
        console.error("Error uploading file:", error);
        return null;
      }
    }
    return null;
  };

  const onSubmit = async (data) => {
    setIsUploading(true);
    try {
      const file = data.image;
      const fileResult = await saveFile(file);

      if (!fileResult) {
        throw new Error("File upload failed");
      }

      const { url: public_url, type } = fileResult;

      const { error } = await supabase.from("gallery").insert([
        {
          public_url,
          fileName: data.description,
          type: type,
          sortorder: 0,
        },
      ]);

      if (error) throw error;

      props.fetchData();
      setOpen(false);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Dialog open={open} onClose={closeDialog} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          {props.label === "Add Media" ? (
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start sm:justify-center">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-center">
                    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                      <div className="pt-4 pb-3 bg-[#F0EDE8] px-6.5 dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                          {props.label}
                        </h3>
                      </div>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-6.5">
                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Media
                            </label>
                            <input
                              type="file"
                              placeholder="Choose Media"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-2 mb-2 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("image", { required: true })}
                            />
                            {errors.image && <p>Media is required.</p>}
                          </div>
                          <div className="mb-4.5">
                            <label className="mb-2.5 mt-3 block text-black dark:text-white">
                              Description <span className="text-meta-1">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Enter description"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("description", { required: true })}
                            />
                            {errors.description && (
                              <p>Description is required.</p>
                            )}
                          </div>

                          <button
                            type="submit"
                            disabled={isUploading}
                            className={`flex w-full justify-center mt-3 rounded bg-brown p-3 font-medium text-white ${
                              isUploading
                                ? "opacity-75 cursor-not-allowed"
                                : "hover:bg-opacity-90"
                            }`}
                          >
                            {isUploading ? (
                              <span className="flex items-center">
                                <svg
                                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                                Uploading...
                              </span>
                            ) : (
                              props.label
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          ) : (
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start sm:justify-center">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-center">
                    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                      <div className="pt-3 pb-2 bg-[#F0EDE8] px-6.5 dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                          {props.label}
                        </h3>
                      </div>
                      <form
                        onSubmit={handleSubmit((data) => {
                          const { SQFT, terraceSQFT, Status } = data;
                          const floorNum = props.id;
                          const unitNum = props.unitNumber;

                          dispatch(
                            update({
                              floorNum,
                              unitNum,
                              SQFT,
                              terraceSQFT,
                              Status,
                            })
                          )
                            .then(() => {
                              console.log("updated successfully");
                              dispatch(getfloorData(floorNum));
                              closeDialog();
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        })}
                      >
                        <div className="p-6.5">
                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Description
                            </label>
                            <input
                              type="text"
                              placeholder="Media Description"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("description", { required: true })}
                            />
                            {errors.description && (
                              <p>Media description is required.</p>
                            )}
                          </div>

                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Media
                            </label>
                            <input
                              type="file"
                              placeholder="Choose Media"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-2 mb-2 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("image", { required: true })}
                            />
                            {errors.image && <p>Media is required.</p>}
                          </div>
                          <button
                            type="submit"
                            className="flex w-full justify-center rounded bg-brown p-3 font-medium text-white hover:bg-opacity-90"
                          >
                            {props.label}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          )}
        </div>
      </div>
    </Dialog>
  );
}
